<template>
<div>
  <div class="contacts">
      <div id="c1"><a v-bind:href="contactsArr.PHONE1_LINK" v-html="contactsArr.PHONES"></a></div>
      <div id="c2">
        <a v-bind:href="contactsArr.EMAIL_LINK" class="email">{{contactsArr.EMAIL}}</a><br/>
        <a target="_blank" v-bind:href="contactsArr.MAPS_LINK" class="addr" v-html="contactsArr.ADDRESS"></a><br/>
        <a target="_blank" v-bind:href="contactsArr.MAPS_LINK" class="shema">Схема проезда</a>
      </div>
      <div id="c3"><a v-bind:href="contactsArr.PHONE2_LINK" v-html="contactsArr.PHONES2"></a></div>
  </div>
  <div class="cont">
      <span>БОЛЬШЕ ПРОЕКТОВ СМОТРИ НА<br/><img style="transform: rotate(270deg);width:30px;" src="../assets/img/str.svg"></span>
      <a target="_blank" v-bind:href="contactsArr.HOUZZ"><img src="../assets/img/houzz.svg"/></a>
    </div>
</div>
</template>

<script>
import axios from 'axios'
const urlInsta = 'https://andreykolesnikov.com/ajax/get_static.php'
export default {
  name: 'Contacts',
  data() {
    return {
      contactsArr: [],
      h: 0
    };
  },
  mounted() {
    axios.get(urlInsta).then(response => {
      this.contactsArr = response.data
      console.log(this.contactsArr);
    });
    
  }
}
</script>